// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { arrowRightThin16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-arrow-right-thin': IconArrowRightThin;
    }
}

/**
 * The icon component for the 'arrowRightThin' icon
 */
export class IconArrowRightThin extends Icon {
    public constructor() {
        super(arrowRightThin16X16);
    }
}

registerIcon('icon-arrow-right-thin', IconArrowRightThin);
export const iconArrowRightThinTag = 'nimble-icon-arrow-right-thin';
